import React, {useCallback} from 'react'
import styled from 'styled-components'
import { Alert, Spinner } from 'react-bootstrap'
import useStores from '../../../stores/useStore'
import PickingControlSubheader from '../../../components/Withdrawals/PickingControl/PickingControlSubheader'
import PickingControlSidebar from '../../../components/Withdrawals/PickingControl/PickingControlSidebar'
import PickingControlContentArea from '../../../components/Withdrawals/PickingControl/PickingControlContentArea'
import { StyledGoodReceiptsContainer } from '../../../components/LocalReceipts/Form/formHelper'
import { useTranslation } from 'react-i18next'
import { ContentArea } from '../../../components/Page/logix2020/ContentArea'
import { TestSidebarRight } from '../../../components/Page/logix2020/TestSidebarRight'
import BigFooter from '../../../components/Footer/BigFooter'
import { FlexWrapper } from '../../../components/Page/logix2020/FlexWrapper'
import PickingControlDataProvider, { usePickingControlDataState } from '../../../stores/PickingControlDataProvider'
import { useWithdrawalsState } from '../../../stores/WithdrawalsProvider.js'
import { useParams } from 'react-router-dom'
import { Observer } from 'mobx-react'
import useMountEffect from '../../../utils/hooks/useMountEffect'

const StyledContentArea = styled(ContentArea)`
   padding: 20px 40px 20px 36px;
   @media (max-width: 1080px) {
    padding: 20px;
    min-height: calc(100vh - 488px);//header+navbar+sidebar=488px
   }
   .added-row {
    label {
      display: block;
    }
  }
`
const PickingControlPageContent = () => {
    const { soId } = useParams()
    const { loadOrderData } = usePickingControlDataState()
    const { lockShippingOrder } = useWithdrawalsState()

    const init = useCallback(
      async () => {
        await lockShippingOrder(soId)
        loadOrderData(soId)
      },
      [soId, lockShippingOrder, loadOrderData]
    )
    
    useMountEffect(() => {
      init()
    }, [init])


    return (
        <>
        <PickingControlSubheader />
        <FlexWrapper>
          <StyledContentArea>
            <PickingControlContentArea />
          </StyledContentArea>
          <TestSidebarRight>
            <PickingControlSidebar />
          </TestSidebarRight>
        </FlexWrapper>
        <BigFooter />
      </>
    )
  }
  
  const PickingControlPage = () => {
    const { uiStore } = useStores()
    const { t } = useTranslation()

    return (<Observer>{() => (
      <PickingControlDataProvider>
        <StyledGoodReceiptsContainer>
          {!uiStore.dashboard || !uiStore.allowPickingProcess
            ? (
              <FlexWrapper>
                <StyledContentArea>
                  {!!uiStore.dashboard
                    ? <Alert variant="danger">{t('withdrawalPage:accessDenied')}</Alert>
                    : <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
                  }
                </StyledContentArea>
                <TestSidebarRight>
                </TestSidebarRight>
              </FlexWrapper>)
            :
            <PickingControlPageContent />
          }
          <BigFooter />
        </StyledGoodReceiptsContainer>
      </PickingControlDataProvider>
    )}</Observer>)
  }
  
  export default PickingControlPage
  